import { Link } from '@mui/material';
import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';

import FlashMessageCreate from '../../components/FlashMessage';
import Input from '../../components/Input/Input';
import { FlashMessageType } from '../../const';
import { InputFields, RawField } from '../../forms';
import Logo from '../Logo';

type TMfa = {
  dataset: {
    email: string;
    actionLink: string;
  };
};

const RESEND_TIMER = 60;

const Mfa: FC<TMfa> = ({ dataset }) => {
  const FormFields = {
    mfaCode: { ...InputFields.mfaCode, required: true },
  } as const satisfies Record<string, RawField>;

  const [timer, setTimer] = useState(RESEND_TIMER);

  const handleClickResetLink = () => {
    let flashMessage = '';
    let flashType = FlashMessageType.Success;

    axios
      .get(dataset.actionLink, { params: { email: dataset.email } })
      .then((res) => {
        flashMessage = res.data.msgUser;
        flashType = res.data.msgType;
      })
      .catch((err) => {
        flashMessage = err.response.data.msgUser;
        flashType = err.response.data.msgType;
      })
      .finally(() => {
        setTimer(RESEND_TIMER);
        FlashMessageCreate({ message: flashMessage, type: flashType, isSelfDestroyable: true });
      });
  };

  useEffect(() => {
    if (timer === 0) {
      return;
    }
    const intervalTimer = setInterval(() => setTimer((currentTime) => currentTime - 1), 1000);

    return () => {
      clearInterval(intervalTimer);
    };
  });

  return (
    <form className='auth-form' method='POST' action={dataset.actionLink}>
      <input type='hidden' name='email' value={dataset.email} hidden />
      <Logo />
      <p>
        MFA（二段階認証）用のセキュリティコードが、<a href={`mailto:${dataset.email}`}>{dataset.email}</a>に送信されました。
        <br />
        コードを入力し、「ログイン」ボタンをクリックしてログインしてください。
      </p>
      <Input
        label={FormFields.mfaCode.label}
        inputProps={{
          tabIndex: FormFields.mfaCode.tabIndex,
          required: FormFields.mfaCode.required,
          maxLength: FormFields.mfaCode.maxLength,
          pattern: FormFields.mfaCode.pattern,
        }}
        type={FormFields.mfaCode.type}
        name={FormFields.mfaCode.name}
        size='small'
        fullWidth
        sx={{ width: '300px' }}
      />
      {timer === 0 ? (
        <Link style={{ cursor: 'pointer' }} onClick={handleClickResetLink} underline='hover'>
          {' '}
          コード再送信
        </Link>
      ) : (
        <p className='auth-form__reset-link'>{timer}秒後に新しいセキュリティコードの発行ができます。</p>
      )}
      <button className='btn btn--main btn--fix' type='submit'>
        ログイン
      </button>
    </form>
  );
};

export default Mfa;
